/** Section element ids used for in-page navigation on the marketing landing page. */
export const MARKETING_LANDING_SECTION_IDS = {
  differentiator: "vs-alternatives",
  faq: "faq",
  features: "pillars",
  finalCta: "get-started",
  home: "home",
  howItWorks: "how-it-works",
  integrations: "integrations",
  pricing: "pricing",
  problem: "why",
} as const;

export type MarketingLandingSectionId =
  (typeof MARKETING_LANDING_SECTION_IDS)[keyof typeof MARKETING_LANDING_SECTION_IDS];
